import type { AdminProfile, CreateProviderBody } from "@/core/types";
import type { ApiRequest, ApiRequestWith } from "@/api/types";
import type { GetAllCseResponse } from "@/core/types/(api)/cse";
import type { GetAllCsmResponse } from "@/core/types/(api)/csm";
import type { GetAllPracticesResponse } from "@/core/types/(api)/practice";
import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import type { UpdateAdminProfileVariables } from "@/portals/admin/(profile)/api/queryFunctions/updateAdminProfile";

import { httpAuth2 } from "../auth";

type AdminRequestsTyped = {
  create_user: ApiRequestWith<void, { body: CreateProviderBody }>;
  fetch_admin_profile: ApiRequest<AdminProfile>;
  fetch_admin_profile_by_id: ApiRequestWith<AdminProfile, { searchParams: { id: string } }>;
  fetch_all_cse: ApiRequest<GetAllCseResponse>;
  fetch_all_csm: ApiRequest<GetAllCsmResponse>;
  fetch_all_practices: ApiRequest<GetAllPracticesResponse>;
  update_profile: ApiRequestWith<void, { body: UpdateAdminProfileVariables }>;
};

export const adminRequestsTyped: AdminRequestsTyped = {
  create_user: function ({ body, context }) {
    return httpAuth2
      .post("/v1/auth/signup", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
      })
      .json<void>();
  },

  fetch_admin_profile: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/admin/profile", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<AdminProfile>();
  },

  fetch_admin_profile_by_id: function ({ context, searchParams }) {
    return httpAuth2
      .post("/v1/admin/profile", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        searchParams,
      })
      .json<AdminProfile>();
  },

  fetch_all_cse: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/admin/all_cse", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GetAllCseResponse>();
  },

  fetch_all_csm: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/admin/all_csm", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GetAllCsmResponse>();
  },

  fetch_all_practices: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/practice/all_practices", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GetAllPracticesResponse>();
  },

  update_profile: function ({ body, context }) {
    return httpAuth2
      .post("/v1/admin/profile_update", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
      })
      .json<void>();
  },
};
